"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prgUrlParamName = exports.PendingRoomStatus = void 0;
var PendingRoomStatus;
(function (PendingRoomStatus) {
    PendingRoomStatus["Pending"] = "Pending";
    PendingRoomStatus["Expired"] = "Expired";
    PendingRoomStatus["Rejected"] = "Rejected";
    PendingRoomStatus["Approved"] = "Approved";
})(PendingRoomStatus = exports.PendingRoomStatus || (exports.PendingRoomStatus = {}));
exports.prgUrlParamName = 'prg';

//# sourceMappingURL=pending-room.constants.js.map
